module.exports = __webpack_public_path__ + "static/media/whatsapp.bf7ed28c.svg";